/**
 * 이상한 방 - 실행 환경에 묻는 것
 *
 * 지금은 "움직임 줄이기" 하나다. 같은 함수가 `ui/juice.ts` · `render/transition.ts` ·
 * `game/session.ts` 세 곳에 글자까지 같은 모양으로 있었고, 셋 다 주석으로 "다른 둘과 같은
 * 규약"이라고 적어 두고 있었다. 규약을 세 번 적는 것보다 함수를 한 번 두는 편이 낫다.
 *
 * ## 왜 `core/`인가
 *
 * 쓰는 쪽이 `ui/` · `render/` · `game/`으로 갈려 있다. `ui/`에 두면 `render/`가 위를 참조하고,
 * `render/`에 두면 `ui/`가 렌더를 참조한다. 셋이 함께 볼 수 있는 층은 `core/`뿐이다.
 *
 * `core/`가 `window`를 만지는 것은 이 파일뿐이고, 그래도 층 방향은 깨지지 않는다 - 방향 규칙이
 * 막는 것은 **위 레이어를 import 하는 것**이지 브라우저 전역을 읽는 것이 아니다.
 * 대신 순수 리듀서(`game/gameState.ts`)는 이 파일을 부르지 않는다. 리듀서가 환경을 물으면
 * 그 순간 서버로 못 옮긴다 - 움직임 줄이기는 규칙이 아니라 연출의 입력이다.
 */

/**
 * 움직임 줄이기 설정.
 *
 * **캐시하지 않는다.** 캐시하면 사용자가 OS 설정을 켜도 새로고침 전까지 안 먹는다.
 * 이 함수는 연출을 시작하는 순간마다 불리며, 그 빈도에서 `matchMedia`는 충분히 싸다.
 *
 * `matchMedia`가 없는 실행기(순수 Node 테스트·워커)에서는 조용히 `false`다. 물어볼 화면이
 * 없다는 것은 줄일 움직임도 없다는 뜻이고, 여기서 던지면 연출 대신 게임이 멈춘다.
 */
export function prefersReducedMotion(): boolean {
  try {
    return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true
  } catch {
    return false
  }
}
